import Vue from 'vue';
import Vuex from 'vuex';
import fastQuoteModule from './modules/fastquote';
import toastr from './modules/toastr';
import fuelLevy from './modules/fuelLevy';
import { initializeApp } from "firebase/app";

var firebaseConfig = {
  apiKey: "AIzaSyCNXy5cCQZdNEnSOOXecJb-ejMfpLOxRK0",
  authDomain: "wrapp-waste.firebaseapp.com",
  databaseURL: "https://wrapp-waste.firebaseio.com",
  projectId: "wrapp-waste",
  storageBucket: "wrapp-waste.appspot.com",
  messagingSenderId: "662553288814",
  appId: "1:662553288814:web:90dd222d1fe2d6766ac67f",
  measurementId: "G-KV0CXS3XRV"
};

initializeApp(firebaseConfig);

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    fastQuote: fastQuoteModule,
    toastr,
    fuelLevy
  }
});
export default store;
